<div class="d-flex justify-content-between">
    <h5 class="fw-semibold ms-2 ">Engine Parameter </h5>
    <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
        (click)="onNoClick()">
</div>


<fieldset class="avs-di-settings-fieldset border-0 p-0 m-0" [disabled]="isReadonly">
<div class="d-flex flex-column gap-3 p-3">
    <mat-form-field class="custom-width-field">
        <mat-label>Input Aktiv</mat-label>
        <mat-select [disabled]="isReadonly" [(ngModel)]="escalationLevelActive">

            @for (level of escalationLevelOptions ; track $index ) {
            <mat-option [value]="level.id"> (S{{level.id}}) {{level.name}} </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field class="custom-width-field">
        <mat-label>Input Nicht Aktiv</mat-label>
        <mat-select [disabled]="isReadonly" [(ngModel)]="escalationLevelNotActive">
            @for (level of escalationLevelOptions ; track $index ) {
            <mat-option [value]="level.id">(S{{level.id}}) {{level.name}}</mat-option>
            }
        </mat-select>
    </mat-form-field>


    <button *ngIf="!isReadonly" class="btn btn-sm btn-outline-primary rounded-0 w-100" (click)="onResetToDefaultClick()">
        Zurücksetzen
    </button>


</div>
</fieldset>




<div class="d-flex justify-content-between border-top w-100">

    <button *ngIf="!isReadonly" class="btn btn-sm btn-outline-success rounded-0" (click)="onSubmitClick()">
        Übernehmen
    </button>
    <button class="btn btn-sm btn-outline-danger  rounded-0" (click)="onNoClick()">
        Schließen
    </button>
</div>



<!-- alternativ
 
einfach immer den body erstellen, 
und die buttons immer anzeigen.


wenn erstellt // übernommen wird gespeichert,
ansonsten so gelassen.

löschen >> ja
erstellen/add >> nein // initial immer da
-->